import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';
import { useAccessToken } from '@/lib/session';

export interface CurrentUser {
  id: string;
  name: string;
  email: string;
  isSuperAdmin: boolean;
  isEmailVerified: boolean;
  isTwoFactorEnabled: boolean;
}

interface MeResponse {
  user: CurrentUser;
  defaultWorkspaceId: string | null;
}

// Platform-level identity (works outside a workspace context). Used by the
// super-admin route guard and admin nav.
export function useCurrentUser() {
  const signedIn = !!useAccessToken();
  return useQuery({
    queryKey: ['me'],
    queryFn: () => apiFetch<MeResponse>('/auth/me'),
    enabled: signedIn,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}
